import React, { useState } from 'react'
import { useApp } from '../../context/AppContext'
import { authedFetch } from '../../lib/api'
import './Payment.css'

export default function Payment() {
  const { user, profile } = useApp()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const gravitate = profile?.gravitate
  const financiar = profile?.profil_financiar
  const pierdereLunara = financiar
    ? Math.round(financiar.venit_lunar * 0.3) // estimare
    : null

  async function handleSubscribe() {
    setLoading(true)
    setError('')

    try {
      const res = await authedFetch('/create-checkout-session', {
        method: 'POST',
        body: JSON.stringify({ email: user?.email }),
      })

      if (!res.ok) throw new Error('checkout failed')

      const { url } = await res.json()
      if (!url) throw new Error('no checkout url')

      // Redirect catre pagina securizata Stripe
      window.location.href = url
    } catch (e) {
      setError('Nu am putut porni plata. Incearca din nou.')
      setLoading(false)
    }
  }

  return (
    <div className="payment-page">
      <div className="payment-card">
        <div className="pay-logo">Slot<span>Free</span></div>

        {/* Profilul AI */}
        {profile && (
          <div className="pay-profile-summary">
            <div className={`pay-level pay-level-${gravitate?.nivel}`}>
              Nivel: {gravitate?.nivel}
            </div>
            <p className="pay-description">{gravitate?.descriere}</p>
            {pierdereLunara && (
              <div className="pay-loss-estimate">
                <div className="pay-loss-num">~{pierdereLunara} lei/luna</div>
                <div className="pay-loss-lbl">estimat pierdut la jocuri</div>
                <div className="pay-loss-year">~{Math.round(pierdereLunara * 12)} lei pe an</div>
              </div>
            )}
          </div>
        )}

        <div className="pay-divider" />

        <h2 className="pay-title">Deblocheaza simulatorul terapeutic</h2>

        <div className="pay-price">
          <span className="pay-price-num">34,99 lei</span>
          <span className="pay-price-period">/ luna</span>
        </div>

        <div className="pay-features">
          <div className="pay-feature">✓ Acces complet la simulatorul personalizat</div>
          <div className="pay-feature">✓ Restul aplicatiei (calendar, jurnal, educatie) ramane gratuit</div>
          <div className="pay-feature">✓ Anulezi oricand, din pagina de profil</div>
          <div className="pay-feature">✓ Plata securizata prin Stripe</div>
        </div>

        <div className="pay-card-placeholder">
          <div className="pay-card-icon">💳</div>
          <p>Plata securizata prin Stripe</p>
          <p className="pay-card-note">Vei fi redirectionat catre pagina securizata Stripe pentru a introduce datele cardului.</p>
        </div>

        {error && <div className="pay-error">{error}</div>}

        <button
          className="btn-primary btn-full btn-lg pay-cta"
          onClick={handleSubscribe}
          disabled={loading}
        >
          {loading ? 'Se incarca...' : 'Aboneaza-te — 34,99 lei/luna'}
        </button>

        <p className="pay-disclaimer">
          Prin continuare esti de acord cu termenii. Te poti dezabona oricand din pagina de profil.
        </p>
      </div>
    </div>
  )
}
